import { ComponentProps } from 'react'

import {
    StyledCard,
    StyledCardHeader,
    StyledCardTitle,
    StyledCardDescription,
    StyledCardAction,
    StyledCardContent,
    StyledCardFooter,
} from './Card.styles'

interface ICardProps extends ComponentProps<'div'> {
    className?: string
}

export const Card = ({ className, ...props }: ICardProps) => {
    return <StyledCard data-slot="card" className={className} {...props} />
}

export const CardHeader = ({ className, ...props }: ICardProps) => {
    return <StyledCardHeader data-slot="card-header" className={className} {...props} />
}

export const CardTitle = ({ className, ...props }: ICardProps) => {
    return <StyledCardTitle data-slot="card-title" className={className} {...props} />
}

export const CardDescription = ({ className, ...props }: ICardProps) => {
    return <StyledCardDescription data-slot="card-description" className={className} {...props} />
}

export const CardAction = ({ className, ...props }: ICardProps) => {
    return <StyledCardAction data-slot="card-action" className={className} {...props} />
}

export const CardContent = ({ className, ...props }: ICardProps) => {
    return <StyledCardContent data-slot="card-content" className={className} {...props} />
}

export const CardFooter = ({ className, ...props }: ICardProps) => {
    return <StyledCardFooter data-slot="card-footer" className={className} {...props} />
}
